// extracted by mini-css-extract-plugin
export default {"expire_time":"expireTime_expire_time__ZbxgE"};